import { observer } from 'mobx-react';
import React from 'react';
import { startIntercomTourById } from '../../../../../../../common/utils/intercom.utils';
import { useStore } from '../../../../../../app/data/root.store';
import { CustomClassEmptyStateCTA, CustomClassEmptyStateLink, CustomClassEmptyStateSubTitle, CustomClassEmptyStateTitle, FiltersHeroEmptyStateWrapper } from '../FiltersHeroEmptyState/FiltersHeroEmptyState.styles';
import { HoldingEntitySvg } from '../../../../../../entities/components/EntityIcons';

export const FiltersHeroEntityEmptyState = observer(() => {
  const { filtersStore, uiStore, metadataStore } = useStore();
  const { title: entityName } = filtersStore.filterTags?.[0] || {};
  
  // Get entity color from metadata store
  const entityColor = entityName && entityName !== 'Unspecified' ? 
    metadataStore?.beneficiaries?.find(beneficiary => beneficiary.name === entityName)?.colorCode : 
    '#F5F5F5';
  
  return (
    <FiltersHeroEmptyStateWrapper>
      <div style={{ 
        width: 72, 
        height: 72, 
        borderRadius: '16px', 
        backgroundColor: entityColor, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginBottom: 14
      }}>
        <HoldingEntitySvg width={36} height={36} color="#1A1B1D" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 14 }}>
        <CustomClassEmptyStateTitle>No results for this filter</CustomClassEmptyStateTitle>
        <CustomClassEmptyStateSubTitle>How to edit items to "{entityName}" entity?</CustomClassEmptyStateSubTitle>
      </div>
      {uiStore.isDesktopView ? 
      <CustomClassEmptyStateCTA onClick={() => { startIntercomTourById('544685') }}>Learn about bulk edit</CustomClassEmptyStateCTA> :
      <CustomClassEmptyStateLink href="https://help.vyzer.co/en/articles/9614825-how-to-bulk-edit-items-in-vyzer-a-step-by-step-guide" target='_blank'>Learn about bulk edit</CustomClassEmptyStateLink>
      }
    </FiltersHeroEmptyStateWrapper>
  )
}) 